import { render, staticRenderFns } from "./promoted-with-percentage.vue?vue&type=template&id=4c1bc848&"
import script from "./promoted-with-percentage.vue?vue&type=script&lang=js&"
export * from "./promoted-with-percentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1bc848')) {
      api.createRecord('4c1bc848', component.options)
    } else {
      api.reload('4c1bc848', component.options)
    }
    module.hot.accept("./promoted-with-percentage.vue?vue&type=template&id=4c1bc848&", function () {
      api.rerender('4c1bc848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/svg/promoted-with-percentage.vue"
export default component.exports